import { render } from "./ClientShow.vue?vue&type=template&id=d6ca5938&scoped=true"
import script from "./ClientShow.vue?vue&type=script&lang=js"
export * from "./ClientShow.vue?vue&type=script&lang=js"

import "./ClientShow.vue?vue&type=style&index=0&id=d6ca5938&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6ca5938"]])

export default __exports__